/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Sheet } from "./Sheet";
export const ListSheetsResponse = core.serialization.object({
    data: core.serialization.list(Sheet),
});
